import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"

class MudarSenhaAlunoAdmin extends Component {


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-6 p-4">     

        <h4>Mudar Senha #</h4>     
        <form>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" id="exampleFormControlInput1" disabled  readOnly/>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Novo Nome" disabled readOnly/>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone</label>
                    <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Novo Nome" disabled readOnly/>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nova Senha</label>
                    <input type="password" class="form-control" id="exampleFormControlInput1" placeholder="Novo Nome" />
                </div>
                <div class="form-group">
                <button class="btn btn-primary mb-2">Atualizar Senha</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(MudarSenhaAlunoAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/mudarsenhaalunos.js